// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.v-application.print-or-save-invoice-dialog {\n  pointer-events: none;\n}\n.v-dialog__content.v-dialog__content--active.print-or-save-invoice-dialog {\n  background-color: rgba(35, 35, 35, 0.7);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
